import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import React from "react";
import {
    ITempAccountPopupProps
} from "../../../common/interfaces/orbit-component-to-sdk-adapter/components-props/temp-account-popup-params";
import {Check} from "@sparkware/app-utils";
import {DialogTextBox} from "../modal-dialog/boxes/text/dialog-text.box";
import {TempAccountPopupBox} from "./boxes/temp-account-popup.box";
import {TempAccountDaysLeftNumberBox} from "./boxes/temp-account-days-left-number.box";
import {ModalDialogActionsComponent} from "../modal-dialog/modal-dialog-actions.component";
import {TempAccountDaysLeftTextBox} from "./boxes/temp-account-days-left-text.box";
import {TEMP_ACCOUNT_STATUS} from "../../../common/const/temp_account_status";
import {GNWP_SOURCES} from "../../services/gnwp/gnwp-consts";
import {ComponentServicesPick} from "../../services/component-services-pick";
import {withServices} from "../../react-hooks/with-services";

interface TempAccountPopupComponentPropsWithServices extends ITempAccountPopupProps, ComponentServicesPick<'gnwp'> {

}

class ComponentBody extends OrbitComponent<TempAccountPopupComponentPropsWithServices> {

    componentDidMount() {
        super.componentDidMount();
        this.services.analytics.getLogger({
            eventName: 'TEMP_ACCOUNT_MESSAGE_SHOWN',
        }).info();
    }

    private _renderDaysLeft = (): React.ReactNode => {
        if (Check.isNullOrUndefined(this.props.daysLeft)) {
            return null;
        }

        const daysLeft = this.props.daysLeft < 0 ? 0 : this.props.daysLeft;
        const text = this.services.translation.translate('temp_account_days_left');

        return <TempAccountDaysLeftTextBox>
            <TempAccountDaysLeftNumberBox className={"cy-temp-account-days-number"}>{daysLeft}</TempAccountDaysLeftNumberBox> {text}
        </TempAccountDaysLeftTextBox>;
    }

    private _buttonCallBack = () => {
        if (this.props.status === TEMP_ACCOUNT_STATUS.DOCUMENTS_NOT_RECEIVED) {

            if (this.props.gnwp.getTempAccountGnwpSource() === GNWP_SOURCES.DOCUMENT_UPLOAD) {
                this.services.externalLinks.then(externalLinks => externalLinks.openUploadDocumentFromMyAccount());
            } else {
                this.services.cashier.openUploadDocumentsFromCashier();
            }

            this.services.analytics.sendAnalytics('temp_account_message', 'upload_docs');

        } else if (this.props.status === TEMP_ACCOUNT_STATUS.PENDING_VERIFICATION) {
            this.services.analytics.sendAnalytics('temp_account_message', 'close_main_btn');
        }

        this.props.dialogHandler.close();
    }

    private _getButtonText = (): string => {
        if (this.props.status === TEMP_ACCOUNT_STATUS.DOCUMENTS_NOT_RECEIVED) {
            return this.services.translation.translate("temp_account_upload_btn");
        }

        return this.services.translation.translate("OK");
    }

    render(){
        return (
          <TempAccountPopupBox>
              {this._renderDaysLeft()}
              <DialogTextBox className={"cy-temp-account-message-body"}>{this.props.bodyText}</DialogTextBox>
              <ModalDialogActionsComponent primaryAction={{
                  onClick: this._buttonCallBack,
                  text: this._getButtonText()
              }}/>
              {this.props.footerText ? <DialogTextBox>{this.props.footerText}</DialogTextBox> : null}
          </TempAccountPopupBox>
        );
    }
}

export const TempAccountPopupComponent = withServices(ComponentBody, ['gnwp']);